module.exports = "<footer class=\"backgroundBlack textContact\">\r\n  <span>\r\n    OPINEMOS TODOS | Paz 1170 | Tel: 54 229 4387711 |  54 249 4421455\r\n    <br>\r\n    Tandil Argentina Email: op@garridoyasociados.com.ar\r\n  </span>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main